import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2965_23201)">
      <path
        d="M12.2292 3.16667H11.5646C11.4244 2.48481 11.0534 1.87215 10.5141 1.43193C9.97483 0.991721 9.30029 0.750879 8.60417 0.75L7.39583 0.75C6.69971 0.750879 6.02517 0.991721 5.48591 1.43193C4.94665 1.87215 4.57564 2.48481 4.43542 3.16667H3.77083C2.96995 3.16763 2.20215 3.4862 1.63584 4.05251C1.06953 4.61882 0.750959 5.38662 0.75 6.1875L0.75 12.2292C0.750959 13.03 1.06953 13.7979 1.63584 14.3642C2.20215 14.9305 2.96995 15.249 3.77083 15.25H12.2292C13.03 15.249 13.7979 14.9305 14.3642 14.3642C14.9305 13.7979 15.249 13.03 15.25 12.2292V6.1875C15.249 5.38662 14.9305 4.61882 14.3642 4.05251C13.7979 3.4862 13.03 3.16763 12.2292 3.16667ZM7.39583 1.95833H8.60417C8.9777 1.95988 9.34163 2.0768 9.64617 2.29309C9.95071 2.50939 10.181 2.81449 10.3055 3.16667H5.6945C5.81901 2.81449 6.04929 2.50939 6.35383 2.29309C6.65837 2.0768 7.0223 1.95988 7.39583 1.95833ZM3.77083 4.375H12.2292C12.7099 4.375 13.1709 4.56596 13.5108 4.90587C13.8507 5.24578 14.0417 5.7068 14.0417 6.1875V8H1.95833V6.1875C1.95833 5.7068 2.14929 5.24578 2.4892 4.90587C2.82911 4.56596 3.29013 4.375 3.77083 4.375ZM12.2292 14.0417H3.77083C3.29013 14.0417 2.82911 13.8507 2.4892 13.5108C2.14929 13.1709 1.95833 12.7099 1.95833 12.2292V9.20833H7.39583V9.8125C7.39583 9.97274 7.45949 10.1264 7.57279 10.2397C7.68609 10.353 7.83977 10.4167 8 10.4167C8.16024 10.4167 8.31391 10.353 8.42721 10.2397C8.54051 10.1264 8.60417 9.97274 8.60417 9.8125V9.20833H14.0417V12.2292C14.0417 12.7099 13.8507 13.1709 13.5108 13.5108C13.1709 13.8507 12.7099 14.0417 12.2292 14.0417Z"
        fill="#151718"
      />
    </g>
    <defs>
      <clipPath id="clip0_2965_23201">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ProposalsIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default ProposalsIcon;
